import React, { useState, useEffect } from "react";
import marked from 'marked';
import { Input } from 'antd';
import "./style.less"

const { TextArea } = Input;

let _content = "";

function Markdown({ content, onChange }) {
  
  const [value, setValue] = useState("");
  if (content !== _content && ![null, undefined].includes(content)) {
    setValue(content)
    _content = content;
  }

  useEffect(() => {
    setHtml(marked(value))
  }, [value])

  const [html, setHtml] = useState("");

  useEffect(() => {
    // 代码高亮
    window.Prism.highlightAll();
  }, [html])

  return (
    <section className="com-markdown">
      <TextArea
        className="com-markdown__model full-col"
        value={value}
        onChange={e => setValue(e.target.value) & onChange(e.target.value)}>
      </TextArea>
      <div className="com-markdown__view markdown" dangerouslySetInnerHTML={{ __html: html }}></div>
    </section>
  )
}

export default Markdown;